import { createContext } from 'react'

export const PaymentContext = createContext({})
export const ShootSelectionContext = createContext({})
export const PaymentErrorContext = createContext({})
export const CustomerDetailsContext = createContext({})
export const BookingConfirmationContext = createContext({})